import { diContainer, serviceNames } from './diContainer';
import { Service, ServiceInitializer } from 'elc-service';
import { ProductUgcServiceStartedUseCase } from '../internal/use-cases/ProductUgcServiceStartedUseCase';
import { OLAPIC_WIDGET } from 'elc-service-view-names';

const { name, version } = __serviceInfo__;

export class ProductUgcService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);

        this.registerView(
            OLAPIC_WIDGET,
            () =>
                import(
                    /* webpackChunkName: 'OlapicWidget' */
                    '../exported/olapic/OlapicWidget'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.olapicWidgetViewController)
        );
    }

    // tslint:disable-next-line:no-any
    public async start(config: any) {
        await super.start(config);
        const useCase = new ProductUgcServiceStartedUseCase([
            'olapicWidgetId',
            'olapicWidgetSrc',
            'olapicInstanceKey',
            'olapicApiKey',
            'olapicLanguage'
        ]);
        await useCase.execute();
    }
}
